import React, { FC, useState } from 'react';
import SmsCodeForm from './SmsCodeForm';
import RequestCodeForm from './RequestCodeForm';
import { CodeValidatedActionEnum } from '../../enum/CodeValidatedActionEnum';

// format="(###) ### ## ##"
//                       prefix="+7 "
//                       phone={values.phone}
//                       action="signUp"
interface Props {
  format: string;
  prefix: string;
  phone: string;
  action: CodeValidatedActionEnum;
}

const SmsSender: FC<Props> = ({ phone, prefix, format, action }) => {
  const [resendAt, setResendAt] = useState(0);

  if (resendAt > 0) {
    return <SmsCodeForm />;
  }

  if (resendAt <= 0) {
    return (
      <RequestCodeForm
        phone={phone}
        action={action}
        recaptchaRequired
        format={format}
        prefix={prefix}
      />
    );
  }

  return null;
};

export default SmsSender;
